import { gql } from '@apollo/client';

import { ListItem as BlurryIconListItem } from 'Components/BlurryIconList/BlurryIconList';
import routes from 'utils/routeTranslator';

export const categoryUrlBySlug = (slug: string): string => {
  return routes.get('front::categories.type', { slug });
};

type L2Category = {
  id: string;
  slug: string;
  name: string;
};

export type L2CategoryListResponse = {
  topCategoryList: L2Category[];
};

export const l2CategoryListQuery = gql`
  query L2CategoryList {
    topCategoryList {
      id
      slug
      name
    }
  }
`;
